<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-tabs>
        <vs-tab label="ข้อมูลตารางสรุปการโอนเงิน">
          <TransferSchedulesTab />
        </vs-tab>
        <vs-tab label="ข้อมูลการโอนเงิน">
          <LoanDetailTab />
        </vs-tab>
        <vs-tab label="ข้อมูลแผนการโอนเงิน">
          <LoanDetailPlanTab />
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import TransferSchedulesTab from "@/views/pages/Accounting/Contract/Detail/Components/LoanDetailInfoTab/Components/TransferSchedulesTab/index.vue";
import LoanDetailTab from "@/views/pages/Accounting/Contract/Detail/Components/LoanDetailInfoTab/Components/LoanDetailTab/index.vue";
import LoanDetailPlanTab from "@/views/pages/Accounting/Contract/Detail/Components/LoanDetailInfoTab/Components/LoanDetailPlanTab/index.vue";

export default {
  name: 'LoanDetailInfoTab',
  components: {
    TransferSchedulesTab,
    LoanDetailTab,
    LoanDetailPlanTab,
  },
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}
</style>
